<template>
  <div class="labelManagement">
    <div class="tag1">
      <div class="text">难度标签</div>
      <div style="margin-top:20px" class="clearfix">
        <div class="fl" style="margin-right:10px">
          <el-input v-model="difficulty" placeholder="请输入标签名称" style="width:200px" size="mini" clearable
            @keyup.enter.native="adminGetOjProblemDifficultyList"></el-input>
        </div>
        <div class="fl">
          <el-button type="primary" @click="adminGetOjProblemDifficultyList" icon="el-icon-search"
            size="mini">查询</el-button>
          <el-button type="primary" @click="add1" size="mini" icon="el-icon-plus">新增</el-button>
        </div>

      </div>
      <el-table height="300" :data="tableData" stripe style="width: 100%;margin-top:20px"
        :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column prop="sort_num" label="排序号">
        </el-table-column>
        <el-table-column prop="title" label="标签名称">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="edit1(scope.row)">编辑</el-button>

            <el-button type="text" size="mini" @click="del1(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

    </div>
    <div class="tag1">
      <div class="text">来源标签</div>
      <div style="margin-top:20px" class="clearfix">
        <div class="fl" style="margin-right:10px">
          <el-input v-model="taglai" placeholder="请输入标签名称" style="width:200px" size="mini" clearable
            @keyup.enter.native="adminGetOjProblemSourceList"></el-input>
        </div>
        <div class="fl">
          <el-button type="primary" @click="adminGetOjProblemSourceList" icon="el-icon-search" size="mini">查询</el-button>

          <el-button type="primary" @click="add2" size="mini" icon="el-icon-plus">新增</el-button>
        </div>

      </div>
      <el-table height="300" :data="tableData1" stripe style="width: 100%;margin-top:20px"
        :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column prop="sort_num" label="排序号">
        </el-table-column>
        <el-table-column prop="title" label="标签名称">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>

            <el-button type="text" size="mini" @click="del(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent1" :current-page="page_no1" :page-size="page_size1"
          layout="total, prev, pager, next, jumper" :total="total1">
        </el-pagination>
      </div>
    </div>
    <div class="tag1">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="算法分组" name="first">
          <div style="margin-top:20px">
            <div style="margin-top:20px" class="clearfix">
              <div class="fl" style="margin-right:10px">
                <el-input v-model="grouping" placeholder="请输入标签名称" style="width:200px" size="mini" clearable
                  @keyup.enter.native="adminGetOjProblemTagGroupList"></el-input>
              </div>
              <div class="fl">
                <el-button type="primary" @click="adminGetOjProblemTagGroupList" icon="el-icon-search"
                  size="mini">查询</el-button>
                <el-button type="primary" @click="add3" size="mini" icon="el-icon-plus">新增</el-button>
              </div>

            </div>
          </div>
          <el-table height="300" :data="tableData2" stripe style="width: 100%;margin-top:20px"
            :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column prop="sort_num" label="排序号">
            </el-table-column>
            <el-table-column prop="title" label="分组名称">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="edit2(scope.row)">编辑</el-button>

                <el-button type="text" size="mini" @click="del2(scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin: 20px; text-align: right">
            <el-pagination @current-change="handleCurrent2" :current-page="page_no2" :page-size="page_size2"
              layout="total, prev, pager, next, jumper" :total="total2">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="算法标签" name="second">
          <div style="margin-top:20px">
            <div style="margin-top:20px" class="clearfix">
              <div class="fl" style="margin-right:10px">
                <el-input v-model="algorithm" placeholder="请输入标签名称" style="width:200px" size="mini" clearable
                  @keyup.enter.native="adminGetOjProblemTagList"></el-input>
              </div>
              <div class="fl">
                <el-button type="primary" @click="adminGetOjProblemTagList" icon="el-icon-search"
                  size="mini">查询</el-button>
                <el-button type="primary" @click="add4" size="mini" icon="el-icon-plus">新增</el-button>
              </div>

            </div>

          </div>
          <el-table height="300" :data="tableData3" stripe style="width: 100%;margin-top:20px"
            :header-cell-style="{ background: '#f5f7fa' }">
            <el-table-column prop="sort_num" label="序号">
            </el-table-column>
            <el-table-column prop="title" label="标签名称">
            </el-table-column>
            <el-table-column prop="groupTitle" label="所属分组">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="edit3(scope.row)">编辑</el-button>

                <el-button type="text" size="mini" @click="del3(scope.row)">移除</el-button>

              </template>
            </el-table-column>
          </el-table>
          <div style="margin: 20px; text-align: right">
            <el-pagination @current-change="handleCurrent3" :current-page="page_no3" :page-size="page_size3"
              layout="total, prev, pager, next, jumper" :total="total3">
            </el-pagination>
          </div>
        </el-tab-pane>

      </el-tabs>

    </div>

    <!-- 添加难度标签 -->
    <el-dialog title="新增难度标签" :visible.sync="dialogVisible" width="30%">
      <el-form ref="addForm" :model="addForm" label-width="80px" :rules="rules">
        <el-form-item prop="sort_num" label="排序号" required>
          <el-input-number v-model="addForm.sort_num" :precision="2" :step="0.01"></el-input-number>
        </el-form-item>

        <el-form-item label="标签名称" prop="title" required>
          <el-input v-model="addForm.title" placeholder="请输入标签名称" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit('addForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加来源标签 -->
    <el-dialog title="新增来源标签" :visible.sync="dialogVisible1" width="30%">
      <el-form ref="addForm1" :model="addForm1" label-width="80px" :rules="rules">
        <el-form-item prop="sort_num" label="排序号" required>
          <el-input-number v-model="addForm1.sort_num" :precision="2" :step="0.01"></el-input-number>
        </el-form-item>

        <el-form-item prop="title" label="标签名称" required>
          <el-input v-model="addForm1.title" placeholder="请输入标签名称" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close1">取 消</el-button>
        <el-button type="primary" @click="submitForm('addForm1')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 算法分组 -->
    <el-dialog title="新增算法分组" :visible.sync="dialogVisible2" width="30%">
      <el-form ref="addForm2" :model="addForm2" label-width="80px" :rules="rules">
        <el-form-item label="排序号" prop="sort_num" required>
          <el-input-number v-model="addForm2.sort_num" :precision="2" :step="0.01"></el-input-number>
        </el-form-item>

        <el-form-item label="分组名称" prop="title" required>
          <el-input v-model="addForm2.title" placeholder="请输入标签名称" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close2">取 消</el-button>
        <el-button type="primary" @click="submitForm1('addForm2')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 算法标签 -->
    <el-dialog title="新增算法标签" :visible.sync="dialogVisible3" width="30%">
      <el-form ref="addForm3" :model="addForm3" label-width="80px" :rules="rules">
        <el-form-item label="排序号" prop="sort_num" required>
          <el-input-number v-model="addForm3.sort_num" :precision="2" :step="0.01"></el-input-number>
        </el-form-item>
        <el-form-item label="标签名称" prop="title" required>
          <el-input v-model="addForm3.title" placeholder="请输入标签名称" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="分组名称" prop="group_id" required>
          <el-select v-model="addForm3.group_id" placeholder="请选择" clearable>
            <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close3">取 消</el-button>
        <el-button type="primary" @click="submitForm2('addForm3')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminAddOrUpdateOjProblemSource,
  adminGetOjProblemSourceList,
  adminDeleteOjProblemSource,
  adminAddOrUpdateOjProblemDifficulty,
  adminGetOjProblemDifficultyList,
  adminDeleteOjProblemDifficulty,
  adminAddOrUpdateOjProblemTagGroup,
  adminGetOjProblemTagGroupList,
  adminDeleteOjProblemTagGroup,
  adminAddOrUpdateOjProblemTag,
  adminGetOjProblemTagList,
  adminDeleteOjProblemTag
}
  from "@/api/adminOj.js";

export default {
  data() {
    return {
      ifIgnore: 0,
      ifIgnore1: 0,
      ifIgnore2: 0,
      ifIgnore3: 0,


      algorithm: '',
      algorithmId: '',
      grouping: '',
      groupingId: '',
      difficulty: '',
      difficultyId: '',
      taglaiId: '',
      taglai: '',
      options: [],
      activeName: 'first',
      addForm3: {
        sort_num: 0,
        title: '',
        group_id: ''

      },
      addForm2: {
        sort_num: 0,
        title: ''
      },
      addForm1: {
        sort_num: 0,
        title: ''
      },
      addForm: {
        sort_num: 0,
        title: ''
      },
      tableData3: [],
      tableData2: [],
      tableData: [],
      tableData1: [],
      page_no: 1,
      page_size: 20,
      total: 20,
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      page_no2: 1,
      page_size2: 20,
      total2: 20,
      page_no3: 1,
      page_size3: 20,
      total3: 20,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      rules: {
        title: [
          {
            required: true,
            message: "请输入标签名称",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入标签名称",
            trigger: "blur",
          },
        ],
        sort_num: [
          {
            required: true,
            message: "请输入排序号",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入排序号",
            trigger: "blur",
          },
        ],
        group_id: [
          {
            required: true,
            message: "请选择标签",
            trigger: "change",
          },
          {
            required: true,
            message: "请选择标签",
            trigger: "blur",
          },
        ]

      },




    }
  },
  mounted() {
    this.adminGetOjProblemSourceList()
    this.adminGetOjProblemDifficultyList()
    this.adminGetOjProblemTagGroupList()
    // this.adminGetOjProblemTagList()
  },
  methods: {
    handleClick(val) {
      console.log(val, 456)
      if (val.name === 'second') {
        this.getList()
        this.adminGetOjProblemTagList()
      }
    },
    //关闭
    close() {
      this.$refs["addForm"].resetFields();
      this.dialogVisible = false
    },
    close1() {
      this.$refs["addForm1"].resetFields();

      this.dialogVisible1 = false
    },
    close2() {
      this.$refs["addForm2"].resetFields();
      this.dialogVisible2 = false
    },
    close3() {
      this.$refs["addForm3"].resetFields();
      this.dialogVisible3 = false
    },
    //获取算法标签
    adminGetOjProblemTagList() {
      adminGetOjProblemTagList({
        title: this.algorithm,
        page_no: this.page_no3,
        page_size: this.page_size3
      }).then((res) => {
        console.log(res, 7787)
        // tableData3
        this.tableData3 = res.ojProblemTagList
        this.total3 = res.total

      })
    },
    //获得分组
    adminGetOjProblemTagGroupList() {
      adminGetOjProblemTagGroupList({
        title: this.grouping,
        page_no: this.page_no2,
        page_size: this.page_size2
      }).then((res) => {
        this.total2 = res.total
        console.log(res, 456798)
        this.tableData2 = res.ojProblemTagGroupList
        this.total2 = res.total

      })
    },
    getList() {
      adminGetOjProblemTagGroupList({
        page_no: 1,
        page_size: 500
      }).then((res) => {
        this.total2 = res.total
        console.log(res, 456798)
        this.options = res.ojProblemTagGroupList

      })
    },
    //获取难度标签
    adminGetOjProblemDifficultyList() {
      adminGetOjProblemDifficultyList({
        title: this.difficulty,
        page_no: this.page_no,
        page_size: this.page_size
      }).then((res) => {
        console.log(res)
        this.total = res.total
        this.tableData = res.ojProblemDifficultyList
      })
    },
    //获取来源标签
    adminGetOjProblemSourceList() {
      adminGetOjProblemSourceList({
        title: this.taglai,
        page_no: this.page_no1,
        page_size: this.page_size1
      }).then((res) => {
        console.log(res, 45)
        this.tableData1 = res.ojProblemSourceList
        this.total1 = res.total
      })
    },
    add4() {
      this.algorithmId = ''
      this.dialogVisible3 = true

    },
    edit3(row) {
      this.getList()
      this.algorithmId = row.id
      this.addForm3.sort_num = row.sort_num
      this.addForm3.title = row.title
      this.addForm3.group_id = row.oj_problem_tag_group_id
      this.dialogVisible3 = true
    },
    del3(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteOjProblemTag({
          id: row.id,
          ifIgnore: 0
        }).then((res) => {
          //   this.$message({
          //     type: 'success',
          //     message: '删除成功!'
          //   });
          //   this.adminGetOjProblemTagList()
          // })
          if (res.is_delete === true) {
            this.$message.success("删除成功");
            this.adminGetOjProblemTagList()
          } else {
            this.$confirm(res.msg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              adminDeleteOjProblemTag({
                id: row.id,
                ifIgnore: 1
              }).then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.adminGetOjProblemTagList()
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    //新增算法标签
    submitForm2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          if (this.algorithmId) {
            console.log(123, 45)
            adminAddOrUpdateOjProblemTag({
              id: this.algorithmId,
              ...this.addForm3
            }).then((res) => {
              this.$message.success('修改成功!')
              console.log(res)
              this.close3()
              this.adminGetOjProblemTagList()
            })
          } else {
            adminAddOrUpdateOjProblemTag({
              ...this.addForm3
            }).then((res) => {
              console.log(res)
              this.$message.success('添加成功!')
              this.close3()
              this.adminGetOjProblemTagList()
            })
          }
        }
      });
    },
    add3() {
      this.groupingId = ''

      this.addForm2.sort_num = 0
      this.addForm2.title = ''
      this.dialogVisible2 = true

    },
    edit2(row) {
      this.groupingId = row.id
      this.addForm2.sort_num = row.sort_num
      this.addForm2.title = row.title
      this.dialogVisible2 = true
    },
    //新增标签分组
    submitForm1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.groupingId) {
            console.log(123, 45)
            adminAddOrUpdateOjProblemTagGroup({
              id: this.groupingId,
              ...this.addForm2
            }).then((res) => {
              this.$message.success('修改成功!')
              this.close2()
              console.log(res)
              this.adminGetOjProblemTagGroupList()

            })

          } else {
            adminAddOrUpdateOjProblemTagGroup({
              ...this.addForm2
            }).then((res) => {
              console.log(res)
              this.$message.success('添加成功!')
              this.close2()
              this.adminGetOjProblemTagGroupList()


            })
          }
        }
      });
    },
    //移除难度标签
    del2(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteOjProblemTagGroup({
          id: row.id,
          ifIgnore: 0
        }).then((res) => {
          //   this.$message({
          //     type: 'success',
          //     message: '删除成功!'
          //   });
          //   // this.adminGetOjProblemTagGroupList()
          // })
          // console.log(res.is_create);

          if (res.is_delete === true) {
            this.$message.success("删除成功");
            this.adminGetOjProblemTagGroupList()
          } else {
            this.$confirm(res.msg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              adminDeleteOjProblemTagGroup({
                id: row.id,
                ifIgnore: 1
              }).then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.adminGetOjProblemTagGroupList()
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    add2() {
      this.taglaiId = ''

      this.addForm1.sort_num = 0
      this.addForm1.title = ''
      this.dialogVisible1 = true
    },
    //新增来源标签
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.taglaiId) {
            console.log(123, 45)
            adminAddOrUpdateOjProblemSource({
              id: this.taglaiId,
              ...this.addForm1
            }).then((res) => {

              this.$message.success('修改成功!')
              this.close1()

              console.log(res)
              this.adminGetOjProblemSourceList()
            })

          } else {
            adminAddOrUpdateOjProblemSource({
              ...this.addForm1
            }).then((res) => {
              console.log(res)
              this.$message.success('添加成功!')
              this.close1()

              this.adminGetOjProblemSourceList()
            })
          }
        }
      });
    },
    //编辑来源标签
    edit(row) {
      this.taglaiId = row.id
      this.addForm1.sort_num = row.sort_num
      this.addForm1.title = row.title
      this.dialogVisible1 = true
    },
    //移除来源标签
    del(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteOjProblemSource({
          id: row.id,
          ifIgnore: 0
        }).then((res) => {
          //   this.$message({
          //     type: 'success',
          //     message: '删除成功!'
          //   });
          //   this.adminGetOjProblemSourceList()
          // })
          if (res.is_delete === true) {
            this.$message.success("删除成功");
            this.adminGetOjProblemSourceList()
          } else {
            this.$confirm(res.msg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              adminDeleteOjProblemSource({
                id: row.id,
                ifIgnore: 1

              }).then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.adminGetOjProblemSourceList()
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    add1() {
      this.difficultyId = ''


      this.addForm.sort_num = 0
      this.addForm.title = ''
      this.dialogVisible = true
    },
    edit1(row) {
      this.difficultyId = row.id
      this.addForm.sort_num = row.sort_num
      this.addForm.title = row.title
      this.dialogVisible = true
    },
    //添加难度标签
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.difficultyId) {
            console.log(123, 45)
            adminAddOrUpdateOjProblemDifficulty({
              id: this.difficultyId,
              ...this.addForm
            }).then(() => {
              this.$message.success('修改成功!')
              this.close()

              this.adminGetOjProblemDifficultyList()
            })
          } else {
            adminAddOrUpdateOjProblemDifficulty({
              ...this.addForm
            }).then(() => {
              this.$message.success('添加成功!')
              this.close()

              this.adminGetOjProblemDifficultyList()
            })
          }
        }
      });
    },
    //移除难度标签
    del1(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteOjProblemDifficulty({
          id: row.id,
          ifIgnore: 0

        }).then((res) => {


          if (res.is_delete === true) {
            this.$message.success("删除成功");
            this.adminGetOjProblemDifficultyList()
          } else {
            this.$confirm(res.msg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              adminDeleteOjProblemDifficulty({
                id: row.id,
                ifIgnore: 1

              }).then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.adminGetOjProblemDifficultyList()
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    handleCurrent(val) {
      this.page_no = val
      this.adminGetOjProblemDifficultyList()
    },
    handleCurrent1(val) {
      this.page_no1 = val
      this.adminGetOjProblemSourceList()
    },
    handleCurrent2(val) {
      this.page_no2 = val
      this.adminGetOjProblemTagGroupList()
    },
    handleCurrent3(val) {
      this.page_no3 = val
      this.adminGetOjProblemTagList()

    }
  }

}
</script>

<style  lang="scss" scoped>
.labelManagement {
  height: 100%;
  width: 100%;
}

.tag1 {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.text {
  font-size: 18px;
  font-weight: bold;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}
</style>